
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"34","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_47725","data-name":"Group 47725","transform":"translate(-1838 -46.85)","fill":"#fff","stroke-width":"1"}},[_c('path',{attrs:{"id":"Polygon_2","data-name":"Polygon 2","d":"M16.161.618a1 1 0 011.35 0l14.263 13.053a1 1 0 01-.675 1.738H2.574a1 1 0 01-.674-1.738z","transform":"translate(1838.265 47.064)","stroke":"#dfe4ef"}}),_c('g',{attrs:{"id":"Rectangle_15777","data-name":"Rectangle 15777","transform":"translate(1838 55.25)","stroke":"#fff"}},[_c('rect',{attrs:{"width":"34","height":"9","stroke":"none"}}),_c('rect',{attrs:{"x":".5","y":".5","width":"33","height":"8","fill":"none"}})])])])
          )
        }
      }
    